import React, {
    useCallback,
    ReactNode,
    forwardRef,
    KeyboardEvent,
} from 'react';
import { navigate } from '@soluto-design/link';
import cls from '@soluto-design/styles/cls';

export interface CardBaseProps {
    className?: string;
    children?: string | ReactNode;
    href?: string;
    dataTheme?: string;
}

const CardBase = forwardRef<HTMLDivElement, CardBaseProps>(
    ({ className, children, href, dataTheme }, ref) => {
        const onClick = useCallback(
            (e) => {
                if (href) {
                    const a = e.target.closest('a');
                    if (!a) {
                        navigate(href);
                    }
                }
            },
            [href],
        );

        const onKeyDown = useCallback(
            (event: KeyboardEvent<HTMLDivElement>) => {
                if (event.key === 'Enter' && href) {
                    navigate(href);
                }
            },
            [href],
        );

        return (
            <div
                {...(!!dataTheme && { 'data-theme': dataTheme })}
                ref={ref}
                className={cls(
                    'w-full h-auto',
                    href &&
                        'cursor-pointer outline-0 focus-visible:outline active:outline-0 disabled:outline-0 outline-stroke-focus',
                    className,
                )}
                onKeyDown={href ? onKeyDown : undefined}
                onClick={href ? onClick : undefined}
                tabIndex={href ? 0 : undefined}
                role={href ? 'link' : undefined}
                aria-label={href ? `Go to ${href}` : undefined}>
                {children}
            </div>
        );
    },
);

CardBase.displayName = 'CardBase';

export default CardBase;
